import styled from 'styled-components'
import {Link as LinkR} from 'react-router-dom'
import {Link as LinkS} from 'react-scroll'
//${({ scrollNav}) => (scrollNav ? '#000' : 'transparent')};
export const Nav = styled.nav`
background: #F2F4F1;
height: 80px;
margin-top: 0;
border-bottom: solid #E0752F 2px;
display: flex;
justify-content: center;
align-items: center;
font-size: 1rem;
position: sticky;
top: 0;
z-index: 10;

@media screen and (max-with:960px) {
    transition: 0.8 all ease;
}
`;

export const NavbarContainer = styled.div`
display:flex;
justify-content: space-between;
height: 80px;
z-index: 1;
width: 100%;
padding: 0 24;
max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`

color: #000;
cursor: pointer;
font-size: 1.5rem;
display: flex;
align-items: center;
margin-left: 24px;
fontweight: 700;
text-decoration: none;
&:hover{
    color:#E0752F;
    transition: 0.3 ease-out
`;

export const MobileIcon = styled.div`
display:none;

@media screen and (max-width: 768px){
    display:block;
    position:absolute;
    top:0;
    right:0;
    transform:translate(-100%, 60%);
    font-size: 1.5rem;
    cursor:pointer;
    color: #000;
}
`;

export const NavMenu = styled.ul`
display:flex;
align-items:center;
list-style:none;
text-align:center;
margin-right:-22px;

@media screen and (max-width: 768px){
    display:none;

}
`;

export const NavItem = styled.li`
height: 80px;

`

export const NavLinks = styled(LinkS)`
margin:10px;
color: #000;
display: flex;
align-items: center;
text-decoration:none;
padding:0 1rem;
height:100%;
cursor:pointer;
font-weight:700;
&:hover{
    color:#E0752F;
    transition: 0.3 ease-out

{/*&:active {
    border-bottom: 3px solid #01bf71;
}*/}

`;

export const NavBtn = styled.nav`
display:flex;
align-items:center;

@media screen and (max-width: 768px){
    display:none;
}
`;

export const NavBtnLink = styled(LinkS)`
border-radius:50px;
background: #E0752F;
white-space: nowrap;
padding: 10px 22px;
color: #010606;
font-size: 16px;
outline: none;
border:none;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover{
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
}
`;